<div class="modal" tabindex="-1" role="dialog" id="classListing" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div [ngClass]="(currLang == 'ar') ? 'modal-content rtl' : 'modal-content'">
            <div *ngIf="loading" class="loading">
                <mat-spinner mode="indeterminate"></mat-spinner>
            </div>
            <div class=" modal-header">
                <h5 class="modal-title">{{clazz?.name}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row class-info-wrapper">
                    <div class="title">
                        {{'grades-classes.grades-classes-modal.class-info' | translate}}
                    </div>
                    <div class="col-lg-6">
                        <div class="class-name-wrapper">
                            <div class="title">
                                {{'grades-classes.grades-classes-modal.class-name' | translate}}
                            </div>
                            <div class="class-name-input">
                                <input type="text" [value]="clazz?.name" disabled>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="assigned-teacher-wrapper" #assignedTeachers>
                            <div class="title">
                                {{'grades-classes.grades-classes-modal.assigned-teachers' | translate}}
                            </div>
                            <div class="assigned-teacher-input" (click)="showTeachersDropdown = !showTeachersDropdown">
                                <div class="teachers-names">
                                    <ng-container *ngIf="selectedClassTeachers.length > 0; else emptyArray">
                                        <ng-container *ngFor="let teacher of selectedClassTeachers; let i = index">
                                            {{ teacher }}{{ i !== selectedClassTeachers.length - 1 ? ', ' : '' }}
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #emptyArray>
                                        {{'grades-classes.grades-classes-modal.no-teachers' | translate}}
                                    </ng-template>
                                </div>
                                <div class="icon">
                                    <svg style="cursor: pointer;" width="14" height="8" viewBox="0 0 14 8" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path id="Path 5489" opacity="0.5" d="M1 1L6.869 5.85889L12.738 1"
                                            stroke="#707070" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </div>
                            </div>
                            <div class="assigned-teacher-dropdown"
                                *ngIf="classTeachers.length > 0 && showTeachersDropdown">
                                <div class="drop-down-value" *ngFor="let teacher of classTeachers">
                                    {{teacher}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg" style="margin-top: 12px; margin-bottom: 20px;">
                        <div class="all-students-self-checkout-wrapper">
                            <div class="title">
                                {{'grades-classes.grades-classes-modal.self-checout-qr' | translate}}
                            </div>
                            <p-dropdown [options]="allStudentsSelfCheckoutOptions"
                                [(ngModel)]="allStudentsSelfCheckoutFlag" (onChange)="onAllStudentsSelfChanged($event)">
                                <ng-template pTemplate="item" let-item>
                                    <div>
                                        {{item.label | translate}}
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="selectedItem" let-item>
                                    <div>
                                        {{item.label | translate}}
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>
                </div>
                <div class="row divider">
                    <div class="col-lg">
                        <hr>
                    </div>
                </div>

                <div class="row class-students-table">
                    <div class="title">
                        {{'grades-classes.grades-classes-modal.class-students' | translate}}
                    </div>
                    <div class="table-container">
                        <table class=" table-hover">
                            <thead class="user-head">
                                <tr>
                                    <th scope="col">
                                        {{'grades-classes.grades-classes-modal.student-name' | translate}}
                                    </th>
                                    <th scope="col">
                                        {{'grades-classes.grades-classes-modal.nationalId' | translate}}
                                    </th>
                                    <th scope="col">
                                        {{'grades-classes.grades-classes-modal.permission' | translate}}
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <p *ngIf="studentsDataArray.length==0;else other_content"
                                    style="color: #6c757d; font-size: .875rem;" class="text-muted"><strong>{{currLang===
                                        'en' ? 'No Results Found' : 'لا توجد بيانات'}}</strong></p>
                                <ng-template #other_content>
                                    <tr class="user-row" *ngFor="let student of studentsDataArray">
                                        <td>
                                            <div class="image-name-wrapper">
                                                <div>
                                                    <img [src]="baseUrl + student?.image_path" alt="">
                                                </div>
                                                <div>
                                                    {{student?.name}}
                                                </div>
                                            </div>
                                        </td>
                                        <td data-pii="redact">{{student?.national_id}}</td>
                                        <td>
                                            <div class="off-container">
                                                <span class="toggle">
                                                    <label class="switch">
                                                        <input type="checkbox"
                                                            [checked]="student?.student_can_self_checkout"
                                                            (change)="switchStudentSelfPermission(student)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" (click)="save()">
                    {{'grades-classes.grades-classes-modal.save-btn' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>